import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  wrapper: {
    marginTop: 16
  }
}));
